export default "https://cdn-static-staging.gokick.com/assets/de9826e8866da471b448810e2f95d57cb57ac3c9/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";